import moment from 'moment-timezone';
import { timing } from '@morf/proto/timing/v1/timing_ts_proto';

export const formatTimestampTo12HourTime = (
  timestamp: timing.v1.Timestamp,
  schedulingTimezone: string
) =>
  moment.unix(timestamp.seconds.low).tz(schedulingTimezone).format('hh:mm A');
